import dayjs from 'dayjs';
import { ISigningSession } from 'app/shared/model/signing-session.model';
import { SignatureStatus } from 'app/shared/model/enumerations/signature-status.model';

export interface IContractSignature {
  id?: number;
  status?: keyof typeof SignatureStatus;
  signerName?: string | null;
  signerEmail?: string | null;
  ipAddress?: string | null;
  signatureValue?: string | null;
  signedTimestamp?: dayjs.Dayjs | null;
  createdTimestamp?: dayjs.Dayjs;
  rejectionReason?: string | null;
  signingSession?: ISigningSession | null;
}

export const defaultValue: Readonly<IContractSignature> = {};
